interface getCroppedImgProps {
  image: any;
}

export function imageToBase64({ image }: getCroppedImgProps) {
  const MAX_SIZE = 300;
  const origW = image.naturalWidth;
  const origH = image.naturalHeight;
  // Calcular factor de escala para mantener proporción:
  const ratio = Math.min(MAX_SIZE / origW, MAX_SIZE / origH, 1);
  const w = Math.round(origW * ratio);
  const h = Math.round(origH * ratio);

  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  if (ctx) {
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(image, 0, 0, w, h);
  }

  const dataURL = canvas.toDataURL("image/png");
  return dataURL;
}

type cropImgProps = {
  image: HTMLImageElement | null;
  width: number;
  height: number;
  x: number;
  y: number;
};

export function cropImageToBase64({
  image,
  width,
  height,
  x,
  y,
}: cropImgProps) {
  const {
    naturalWidth,
    naturalHeight,
    width: widthImg,
    height: heightImg,
  } = image as HTMLImageElement;
  const canvas = document.createElement("canvas");
  const scaleX = naturalWidth / widthImg;
  const scaleY = naturalHeight / heightImg;
  canvas.width = width * scaleX;
  canvas.height = height * scaleY;
  const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
  ctx.drawImage(
    image as HTMLImageElement,
    x * scaleX,
    y * scaleY,
    width * scaleX,
    height * scaleY,
    0,
    0,
    width * scaleX,
    height * scaleY
  );
  return canvas.toDataURL("image/jpeg");
}
